import { IStep } from "../../components/Atoms/StepIndicator";

export const AGENDAMENTO_V2_STEPS: IStep[] = [
  { label: "Modalidade" },
  { label: "Local" },
  { label: "Serviço" },
  { label: "Veículo" },
  { label: "Pagamento" },
  { label: "Data e Hora" },
];

export const AGENDAMENTO_V2_LOTE_STEPS: IStep[] = [
  { label: "Modalidade" },
  { label: "Local" },
  { label: "Serviço" },
  { label: "Planilha" },
];

const STEP_BY_PATH_SEGMENT: Record<string, number> = {
  loja: 2,
  domicilio: 2,
  delivery: 2,
  itinerantes: 2,
  servicos: 3,
  veiculo: 4,
  "primeiro-emplacamento": 4,
  transferencia: 4,
  vistoria: 4,
  emplacamento: 4,
  "primeiro-registro": 4,
  pagamento: 5,
  pix: 5,
  boleto: 5,
  "confirmar-horario": 6,
  // 7 = AGENDAMENTO_V2_STEPS.length + 1, the "all steps done" sentinel (see getStepStatus)
  "confirmar-agendamento": 7,
  "dados-agendamento": 7,
  // 5 = AGENDAMENTO_V2_LOTE_STEPS.length + 1, the lote flow's own "all steps done" sentinel
  "agendamentos-criados": 5,
};

const AGENDAMENTO_ROOT_SEGMENTS = ["agendamento", "agendamento-lote"];

export const isAgendamentoLotePath = (pathname: string): boolean => {
  const segments = pathname.split("/").filter(Boolean);
  return segments[0] === "agendamento-lote";
};

export const getStepFromPath = (pathname: string): number | null => {
  const segments = pathname.split("/").filter(Boolean);

  if (!AGENDAMENTO_ROOT_SEGMENTS.includes(segments[0])) {
    return null;
  }

  if (segments.length === 1) {
    return 1;
  }

  for (let i = segments.length - 1; i >= 0; i--) {
    const step = STEP_BY_PATH_SEGMENT[segments[i]];
    if (step) {
      return step;
    }
  }

  return null;
};
